import {
  Edit,
  SimpleForm,
  TextInput,
  TextField,
  EmailField,
  DateField,
  ReferenceField,
  FunctionField,
} from 'react-admin';

export const InquiryEdit = () => (
  <Edit>
    <SimpleForm>
      {/* Read-only fields */}
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="company" />
      <TextField source="phone" />
      <EmailField source="email" />
      <TextField source="comment" />
      
      <ReferenceField source="userId" reference="users" link="show" emptyText="Анонимная заявка">
        <FunctionField render={(record: any) => 
          record ? `${record.firstName || ''} ${record.lastName || ''}`.trim() : ''
        } />
      </ReferenceField>
      
      <TextField source="source" emptyText="-" />
      <DateField source="createdAt" showTime />
      
      {/* Editable field */}
      <TextInput 
        source="adminNotes" 
        label="Заметки администратора"
        multiline
        rows={4}
        fullWidth
        helperText="Внутренние заметки для администраторов"
      />
    </SimpleForm>
  </Edit>
);
